import React, { ReactNode } from 'react';
import { useScrollAnimation } from 'hooks/useScrollAnimation';
import { StyledInnerSection } from './styled';

interface InnerSectionProps {
  children: ReactNode;
  isCarousel?: boolean;
}

export const InnerSection = ({ children, isCarousel }: InnerSectionProps): JSX.Element => {
  const ref = useScrollAnimation();

  return (
    <StyledInnerSection ref={ref} isCarousel={isCarousel}>
      {children}
    </StyledInnerSection>
  );
};
